import { FC, ReactNode } from "react";

import { Stack } from "@mui/material";

import { useTranslate } from "@/common/hooks/useTranslate";
import { DashboardTypography } from "@/dashboard-design-system/Typography";

interface AdjustTipDetailsProps {
  tipAmount: string;
  amountField: ReactNode;
  refundAmount: string;
  organizationName: string;
  paymentLabel: string;
  paymentMethodLabel: string | null;
  scheduledForLabel: string | null;
}

export const AdjustTipDetails: FC<AdjustTipDetailsProps> = ({
  tipAmount,
  amountField,
  refundAmount,
  organizationName,
  paymentLabel,
  paymentMethodLabel,
  scheduledForLabel,
}) => {
  const { t } = useTranslate();
  const rows = [
    { label: t("dashboard", "donorAssistant.approval.adjustTip.payment"), value: paymentLabel },
    { label: t("dashboard", "donorAssistant.approval.adjustTip.refund"), value: refundAmount },
    ...(paymentMethodLabel
      ? [{ label: t("dashboard", "donorAssistant.approval.adjustTip.backTo"), value: paymentMethodLabel }]
      : []),
    ...(scheduledForLabel
      ? [{ label: t("dashboard", "donorAssistant.approval.adjustTip.refundDate"), value: scheduledForLabel }]
      : []),
  ];
  return (
    <Stack spacing={1.5}>
      <DashboardTypography variant="body2" vibe="text-neutral-moderate">
        {t("common", "donorRefund.hero.tipInfo", { tipAmount })}
      </DashboardTypography>
      {amountField}
      <Stack spacing={0.5}>
        {rows.map(({ label, value }) => (
          <Stack key={label} direction="row" justifyContent="space-between" spacing={2}>
            <DashboardTypography variant="body2" vibe="text-neutral-moderate">
              {label}
            </DashboardTypography>
            <DashboardTypography variant="subtitle2" vibe="text-neutral-intense" sx={{ textAlign: "right" }}>
              {value}
            </DashboardTypography>
          </Stack>
        ))}
      </Stack>
      <DashboardTypography variant="caption" vibe="text-neutral-moderate">
        {t("common", "donorRefund.tipAdjustment.disclaimer", { organizationName })}{" "}
        {scheduledForLabel
          ? t("dashboard", "donorAssistant.approval.adjustTip.scheduledTiming")
          : t("dashboard", "donorAssistant.approval.adjustTip.timing")}
      </DashboardTypography>
    </Stack>
  );
};
